import { inject, Injectable } from '@angular/core';
import { EmojiFrequentlyService } from '@ctrl/ngx-emoji-mart';

@Injectable({
  providedIn: 'root',
})
export class EmojiStoreService {
  private readonly emojiFrequentlyService = inject(EmojiFrequentlyService);

  getFrequentlyEmoji(): string[] {
    return this.emojiFrequentlyService.get(5, 1);
  }
}
